(function () {
  var BUSY = false;
  var DEAD = false;
  var TIMER = null;
  var lastSignature = null;
  var sameSignatureCount = 0;
  var mutations = 0;

  var MAX_SAME_SIGNATURE = 2;

  var MAX_MUTATIONS = 12;
  var DEBOUNCE_MS = 50;

  function schedule() {
    clearTimeout(TIMER);
    TIMER = setTimeout(reconcile, DEBOUNCE_MS);
  }

  function sectionsToRender() {
    var sections = [];
    if (document.querySelector('cart-drawer')) sections.push('cart-drawer');

    var items = document.getElementById('main-cart-items');
    if (items && items.dataset.id) sections.push(items.dataset.id);

    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) sections.push(footer.dataset.id);

    sections.push('cart-icon-bubble');
    return sections.join(',');
  }

  function sectionInnerHTML(html, selector) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var found = parsed.querySelector(selector);
    return found ? found.innerHTML : '';
  }

  function replace(id, selector, html) {
    if (!html) return;
    var host = document.getElementById(id);
    if (!host) return;
    var target = selector ? host.querySelector(selector) : host;
    if (target) target.innerHTML = sectionInnerHTML(html, selector || '#' + id);
  }

  function applySections(state) {
    var sections = state.sections;
    if (!sections) return;

    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      var host = document.getElementById('CartDrawer');
      if (host) {
        host.innerHTML = sectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
        var overlay = host.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
      }

      if (typeof state.item_count === 'number') {
        drawer.classList.toggle('is-empty', state.item_count === 0);
      } else {
        drawer.classList.remove('is-empty');
      }

      if (typeof getAndShowUpsells === 'function' && drawer.classList.contains('active')) {
        getAndShowUpsells();
      }
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      bubble.innerHTML = sectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
    }

    var items = document.getElementById('main-cart-items');
    if (items && items.dataset.id && sections[items.dataset.id]) {
      replace('main-cart-items', '.js-contents', sections[items.dataset.id]);
    }

    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id && sections[footer.dataset.id]) {
      replace('main-cart-footer', '.js-contents', sections[footer.dataset.id]);
    }
  }

  function post(url, body) {
    BUSY = true;
    mutations += 1;

    return fetch(window.Shopify.routes.root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(applySections)
      .catch(function () {
        DEAD = true;
      })
      .then(function () {
        BUSY = false;
      });
  }

  function addGift(controller) {
    justAdded = true;

    return post('cart/add.js', {
      items: [
        {
          id: Number(controller.dataset.variantId),
          quantity: 1,
          properties: { _gwp: 'true' }
        }
      ],
      sections: sectionsToRender(),
      sections_url: window.location.pathname
    });
  }

  function setGiftQuantity(key, quantity) {
    return post('cart/change.js', {
      id: key,
      quantity: quantity,
      sections: sectionsToRender(),
      sections_url: window.location.pathname
    });
  }

  function giftKeys(controller) {
    return (controller.dataset.giftKeys || '').split('|').filter(Boolean);
  }

  function reconcile() {
    if (DEAD || BUSY) return;

    var controller = document.querySelector('gwp-controller');
    if (!controller) return;

    if (mutations >= MAX_MUTATIONS) {
      DEAD = true;
      return;
    }

    var threshold = Number(controller.dataset.threshold);
    var qualifying = Number(controller.dataset.qualifyingTotal);
    var giftQuantity = Number(controller.dataset.giftQuantity);
    var ownedQuantity = Number(controller.dataset.giftOwned);
    var canAdd = controller.dataset.canAdd === 'true';
    var forceRemove = controller.dataset.forceRemove === 'true';
    var keys = giftKeys(controller);

    if (!threshold || isNaN(qualifying)) return;

    var signature =
      giftQuantity + ':' + ownedQuantity + ':' + qualifying + ':' + canAdd + ':' + forceRemove;

    var action = null;
    if (keys.length > 0 && (forceRemove || qualifying < threshold)) {
      action = function () { return setGiftQuantity(keys[0], 0); };
    } else if (keys.length > 1) {
      action = function () { return setGiftQuantity(keys[keys.length - 1], 0); };
    } else if (ownedQuantity > 1) {
      action = function () { return setGiftQuantity(keys[0], 1); };
    } else if (giftQuantity === 0 && canAdd && qualifying >= threshold) {
      action = function () { return addGift(controller); };
    }

    if (!action) {
      lastSignature = null;
      sameSignatureCount = 0;
      return;
    }

    if (signature === lastSignature) {
      sameSignatureCount += 1;
      if (sameSignatureCount >= MAX_SAME_SIGNATURE) {
        DEAD = true;
        return;
      }
    } else {
      sameSignatureCount = 0;
    }
    lastSignature = signature;

    action();
  }

  var CELEBRATION_KEY = 'gwp-celebrated';
  var CONFETTI_COUNT = 90;
  var CONFETTI_MS = 2200;
  var GRAVITY = 900;
  var DRAG = 0.86;
  var celebrating = false;
  var justAdded = false;

  function celebrationDone() {
    try {
      return sessionStorage.getItem(CELEBRATION_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function setCelebrationDone(done) {
    try {
      if (done) {
        sessionStorage.setItem(CELEBRATION_KEY, '1');
      } else {
        sessionStorage.removeItem(CELEBRATION_KEY);
      }
    } catch (error) {
    }
  }

  function maybeCelebrate(controller) {
    var threshold = Number(controller.dataset.threshold);
    var qualifying = Number(controller.dataset.qualifyingTotal);
    var forceRemove = controller.dataset.forceRemove === 'true';
    var earned =
      Number(controller.dataset.giftQuantity) > 0 &&
      !forceRemove &&
      threshold > 0 &&
      qualifying >= threshold;

    if (!earned) {
      setCelebrationDone(false);
      return;
    }

    if (celebrationDone()) return;

    if (document.visibilityState === 'hidden') return;

    setCelebrationDone(true);

    if (justAdded) {
      justAdded = false;
      openDrawer();
    }

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    confetti();
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');

    if (!drawer || typeof drawer.open !== 'function') return;
    if (drawer.classList.contains('active')) return;
    if (drawer.classList.contains('is-empty')) return;

    drawer.open();
  }

  function mix(hex, amount) {
    var value = hex.replace('#', '');
    if (value.length === 3) {
      value = value[0] + value[0] + value[1] + value[1] + value[2] + value[2];
    }
    if (value.length !== 6) return hex;

    var target = amount > 0 ? 255 : 0;
    var weight = Math.abs(amount);
    var parts = [];

    for (var i = 0; i < 3; i += 1) {
      var channel = parseInt(value.substr(i * 2, 2), 16);
      parts.push(Math.round(channel + (target - channel) * weight));
    }

    return 'rgb(' + parts.join(',') + ')';
  }

  function confettiPalette() {
    var base = '';

    try {
      base = getComputedStyle(document.documentElement).getPropertyValue('--gwp-colour').trim();
    } catch (error) {
      base = '';
    }

    if (!base) base = '#a300ff';

    return [base, mix(base, 0.45), mix(base, 0.7), mix(base, -0.25)];
  }

  function confetti() {
    if (celebrating) return;
    celebrating = true;

    var canvas = document.createElement('canvas');
    canvas.className = 'gwp-confetti';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    var context = canvas.getContext('2d');
    var ratio = Math.min(window.devicePixelRatio || 1, 2);
    var width = window.innerWidth;
    var height = window.innerHeight;

    canvas.width = width * ratio;
    canvas.height = height * ratio;
    context.scale(ratio, ratio);

    var palette = confettiPalette();
    var pieces = [];

    for (var i = 0; i < CONFETTI_COUNT; i += 1) {
      var fromLeft = i % 2 === 0;
      var spread = Math.random();

      pieces.push({
        x: fromLeft ? -20 : width + 20,
        y: height * (0.72 + Math.random() * 0.2),
        vx: (fromLeft ? 1 : -1) * (620 + spread * 640),
        vy: -(760 + Math.random() * 520),
        size: 6 + Math.random() * 7,
        tilt: Math.random() * Math.PI,
        spin: (Math.random() - 0.5) * 12,
        colour: palette[i % palette.length]
      });
    }

    var start = null;

    function frame(now) {
      if (start === null) start = now;

      var elapsed = now - start;
      var step = Math.min(32, now - (frame.last || now)) / 1000;
      frame.last = now;

      context.clearRect(0, 0, width, height);
      context.globalAlpha = elapsed > CONFETTI_MS * 0.65
        ? Math.max(0, 1 - (elapsed - CONFETTI_MS * 0.65) / (CONFETTI_MS * 0.35))
        : 1;

      for (var i = 0; i < pieces.length; i += 1) {
        var piece = pieces[i];

        piece.vx *= Math.pow(DRAG, step * 6);
        piece.vy += GRAVITY * step;
        piece.x += piece.vx * step;
        piece.y += piece.vy * step;
        piece.tilt += piece.spin * step;

        context.save();
        context.translate(piece.x, piece.y);
        context.rotate(piece.tilt);
        context.fillStyle = piece.colour;

        context.fillRect(
          -piece.size / 2,
          -piece.size / 2,
          piece.size,
          piece.size * Math.abs(Math.cos(piece.tilt))
        );
        context.restore();
      }

      if (elapsed < CONFETTI_MS) {
        window.requestAnimationFrame(frame);
        return;
      }

      canvas.remove();
      celebrating = false;
    }

    window.requestAnimationFrame(frame);
  }

  if (!window.customElements.get('gwp-controller')) {
    window.customElements.define(
      'gwp-controller',
      class extends HTMLElement {
        connectedCallback() {
          schedule();
          maybeCelebrate(this);
        }
      }
    );
  }

  document.addEventListener('DOMContentLoaded', schedule);
})();
